const urlApiDev = process.env.DEV_API_CIELO
const urlApiProd = process.env.PROD_API_CIELO
const keyDev = process.env.DEV_CIELO_KEY
const keyProd = process.env.PROD_CIELO_KEY

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'leonardo.senhadigitalplus.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd
const key = isDev ? keyDev : keyProd
const headers = {
  'x-api-key': `${key}`,
  'content-type': 'application/json',
}

export const state = () => ({
  paymentCielo: null,
})

export const getters = {}

export const mutations = {}

export const actions = {
  async createTokenCreditCardCielo({ commit }, token) {
    const data = await this.$axios.$post(`${urlApi}/token`, token, { headers })
    return data
  },

  async paymentCreditCardCielo({ commit }, paymentData) {
    const data = await this.$axios.$post(
      `${urlApi}/cartao-credito`,
      paymentData,
      { headers }
    )
    return data
  },
}
